import ScrollMagic from 'scrollmagic/scrollmagic/minified/ScrollMagic.min';
import jQuery from 'jquery';
// import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min';

export default function stickProductImage() {
    const elContainer = '.product__details';
    const el = '.product__image';
    const header = '.header';
    const mobileBreak = 767;

    const controller = new ScrollMagic.Controller({
        globalSceneOptions:
            {
                triggerHook: 'onLeave',
            },
    });

    function initScene(prevScene = null) {
        // destroy previous scene
        if (prevScene) prevScene.destroy(true);

        if (jQuery(window).outerWidth() > mobileBreak) {
            // const offset = jQuery(header).outerHeight(true);
            const elHeight = jQuery(el).outerHeight(true);

            const offset = ((jQuery(window).height() - elHeight) / 2)
                + (jQuery(header).outerHeight(true) / 2);
            const duration = jQuery(elContainer).height() - elHeight;

            if (duration > 0) {
                return new ScrollMagic.Scene({
                    triggerElement: el,
                    duration,
                    offset: -offset,
                })
                    .setPin(el)
                    // .addIndicators()
                    .addTo(controller);
            }
        }

        return null;
    }

    jQuery(() => {
        if (ScrollMagic) {
            let scene = initScene();

            let resizeTimeout;
            window.onresize = () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => { scene = initScene(scene); }, 300);
            };
        }
    });
}
